<div class="marches-container">
  <div class="marches-wrapper">
    <div class="marches-header">
      <div class="marches-title-row">
        <h3 class="marches-title">Marchés</h3>

        <div class="report-actions">
          <button
            *ngIf="hasAccess(['SU', 'PRMP'])"
            class="report-button report-pdf"
            title="Télécharger le rapport PPM (PDF)"
            aria-label="Télécharger le rapport PPM au format PDF"
            (click)="telechargerRapportPpm()"
          >
            <mat-icon>picture_as_pdf</mat-icon>
          </button>

          <button
            *ngIf="hasAccess(['SU', 'PRMP'])"
            class="report-button report-xlsx"
            title="Télécharger le rapport PPM (XLSX)"
            aria-label="Télécharger le rapport PPM au format XLSX"
            (click)="telechargerRapportPpmXlsx()"
          >
            <mat-icon>table_chart</mat-icon>
          </button>
        </div>
      </div>

      <h4 class="marches-subtitle">Gestion de vos marchés</h4>
    </div>

    <div class="marches-content">
      <app-ongletlayout [ongletLinks]="tableLinkForMarches" storageId="marches">
        <div>
          <router-outlet></router-outlet>
        </div>
      </app-ongletlayout>
    </div>
  </div>
</div>